module.exports = __webpack_public_path__ + "img/sports-medal.ca588f78.png";